export default class AlMediaSelectorModalController {

    constructor($uibModalInstance, $scope, http, env, startDirectory, allowedMimes, preSelectedFile) {
        this.modalInstance = $uibModalInstance;
        this.scope = $scope;
        this.http = http;
        this.env = env;

        this.selectedFile = null;
        this.startDirectory = startDirectory || null;
        this.preSelectedFile = preSelectedFile || null;
        this.allowedMimes = allowedMimes || [];
    }

    handleFileSelection(file) {
        this.modalInstance.close({
            file: file
        });
    }

    dismiss() {
        this.modalInstance.dismiss();
    }
}

AlMediaSelectorModalController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$http',
    'Env',
    'startDirectory',
    'allowedMimes',
    'preSelectedFile'
];



// WEBPACK FOOTER //
// ./src/app/modules/media/controllers/modals/media-selector-modal-controller.js